import { ArrowDropDown, ArrowDropUp, FilterList } from '@mui/icons-material';
import { Button, Divider, Grid, Box } from '@mui/material';
import { Theme } from '@mui/material/styles';
import makeStyles from '@mui/styles/makeStyles';
import { useState, FC } from 'react';
import useCollapse from 'react-collapsed';

interface IFiltersLayout {
  children?: React.ReactNode;
  withExpand?: boolean;
  alignItems?: 'center' | 'flex-start' | 'flex-end' | 'stretch' | 'baseline';
  hasMarginBottom?: boolean;
}

export const FiltersLayout: FC<IFiltersLayout> = ({
  children,
  withExpand,
  alignItems = 'center',
  hasMarginBottom = true
}) => {
  const [isMobileFilterButtonOpen, toggleMobileFilter] = useState<boolean>(false);
  const classes = useStyles({ isMobileFilterButtonOpen, withExpand, hasMarginBottom });

  const { getCollapseProps, getToggleProps, isExpanded } = useCollapse();
  if (withExpand) {
    return (
      <>
        <Box
          className={'print--none'}
          display="flex"
          paddingBottom="1rem"
          width={{
            xs: '100%',
            sm: 'auto'
          }}
        >
          <Button
            color="secondary"
            variant="contained"
            startIcon={<FilterList />}
            endIcon={isExpanded ? <ArrowDropUp /> : <ArrowDropDown />}
            {...getToggleProps()}
          >
            Filters
          </Button>
        </Box>
        {!isExpanded && <Divider className={classes.divider} />}
        <Box {...getCollapseProps()}>
          <Grid container spacing={1} alignItems="center">
            {children}
          </Grid>
        </Box>
      </>
    );
  }
  return (
    <>
      <Button
        color="secondary"
        variant="contained"
        className={classes.mobileButton}
        startIcon={<FilterList />}
        endIcon={isMobileFilterButtonOpen ? <ArrowDropUp /> : <ArrowDropDown />}
        onClick={() => {
          toggleMobileFilter(!isMobileFilterButtonOpen);
        }}
      >
        Filters
      </Button>
      {!isMobileFilterButtonOpen && <Divider className={classes.divider} />}
      <Grid container spacing={1} alignItems={alignItems} className={classes.wrapper}>
        {children}
      </Grid>
    </>
  );
};

const useStyles = makeStyles<
  Theme,
  { isMobileFilterButtonOpen?: boolean; withExpand?: boolean; hasMarginBottom?: boolean }
>((theme: Theme) => ({
  mobileButton: {
    width: '100%',
    [theme.breakpoints.up('sm')]: {
      display: 'none'
    }
  },
  wrapper: ({ isMobileFilterButtonOpen }) =>
    isMobileFilterButtonOpen
      ? {
          marginTop: 10,
          marginBottom: 10,
          display: 'flex'
        }
      : {
          display: 'none',
          marginBottom: ({ hasMarginBottom }) => (hasMarginBottom ? theme.spacing(1) : 0),
          [theme.breakpoints.up('sm')]: {
            display: 'flex'
          }
        },
  divider: {
    display: 'block',
    marginBottom: theme.spacing(1),
    [theme.breakpoints.up('sm')]: {
      display: 'none'
    }
  }
}));
